// extracted by mini-css-extract-plugin
export default {"container":"DeckPlansModal_container__Oar2s","image":"DeckPlansModal_image__Xhqgf"};